export enum WebEventNames {
  WEB_SEARCH_VIEW = 'web-search.view',
  WEB_SEARCH_RESULT_LIST_ENTER_ARTICLE = 'web-search.result-list.enter-article',
  WEB_SEARCH_SEARCH_BAR_SEARCH = 'web-search.search-bar.search',
  WEB_SEARCH_HOT_KEYWORD_SEARCH = 'web-search.hot-keyword.search',
  WEB_SEARCH_ARTICLE_HASHTAG_SEARCH = 'web-search.article-hashtag.search',
  WEB_SEARCH_RESULT_LIST_SEARCH = 'web-search.result-list.search',
  WEB_SEARCH_FILTER_SWITCH = 'web-search.filter.switch',
  WEB_SEARCH_SORT_SWITCH = 'web-search.sort.switch',
}
